import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { emilyEx } from "../characters/EmilyEx";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { doDoorRing, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8EmilyAndExDoorAfter } from "./V8";

export const V8EmilyAndExDoor = async (): Promise<any> => {
    doDoorRing();
    if (Game.seenScenarios.includes(`V8JoeMCMorning`)) {
        mc.think(`Huh? Did Joey forget something?`);


    } else {
        // TODO: Joey hate
    }
    ImageClass.setImage(images.v8.V8EmilyExVisit_1, { duration: 1, wait: true, hideText: true });
    ImageClass.setImage(images.v8.V8EmilyExVisit_2);
    mc.think(`Who the fuck is this?`);
    mc.talk(`Hey...?`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_3);
    emilyEx.talk(`Hey. Is Emily home?`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_4);
    mc.talk(`Who are you?`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_3);
    emilyEx.talk(`Oh, right. Sorry. I'm ${emilyEx.name}, her... A... Friend.`);
    mc.think(`Oh shit! Is this her ex?`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_4);
    mc.talk(`She is not home right now.`);

    ImageClass.setImage(images.v8.V8EmilyExVisit_3);
    emilyEx.talk(`I guess you are ${mc.name}?`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_4);
    mc.talk(`Right.`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_3);
    emilyEx.talk(`Nice meeting you. Emily told me a bit about you.`);
    emilyEx.talk(`Do you have any idea when she is going to be back?`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_4);
    mc.talk(`Not really... No.`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_3);
    emilyEx.talk(`Can I wait for her?`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_4);
    mc.talk(`Sure... But it might take a while...`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_3);
    emilyEx.talk(`That's not a problem for me.`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_4);
    mc.talk(`Suit yourself.`);
    mc.talk(`By the way... What's with the plant?`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_5);
    emilyEx.talk(`Oh this....`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_3);
    emilyEx.talk(`Emily always says she feels bad that flowers need to die just to make other people happy...`);
    emilyEx.talk(`That's why she prefers plants...`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_4);
    mc.talk(`Aren't plant dying as well?`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_3);
    emilyEx.talk(`I never gave it too much thought... I just know she prefers them, so that's what I get for her.`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_4);
    mc.talk(`Makes sense.`);
    mc.talk(`Well, her room is down the hall and to the left.`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_3);
    emilyEx.talk(`Thank you.`);
    ImageClass.setImage(images.v8.V8EmilyExVisit_6, { duration: 1 });
    mc.think(`This is going to be interesting.`);

    return jump(V8EmilyAndExDoorAfter, "V8EmilyAndExDoorAfter");
};
